import { render } from "./LightboxSellerRanking.vue?vue&type=template&id=066fdb32&scoped=true&ts=true"
import script from "./LightboxSellerRanking.vue?vue&type=script&lang=ts"
export * from "./LightboxSellerRanking.vue?vue&type=script&lang=ts"

import "./LightboxSellerRanking.vue?vue&type=style&index=0&id=066fdb32&lang=scss&scoped=true"
import "./LightboxSellerRanking.vue?vue&type=style&index=1&id=066fdb32&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066fdb32"]])

export default __exports__